function addCartDrawerFormEventListeners() {
  const cartDrawerForm = document.querySelector(
    '.cart-drawer form[action$="/cart"]'
  )

  if (!cartDrawerForm) return null

  customInputNumberListeners(cartDrawerForm)

  handleQuantityButtons(cartDrawerForm, updateCartDrawer)

  handleCartAddFreeGift()

  //close cart drawer
  document
    .querySelectorAll('#close-cart-drawer, #cart-drawer-background')
    .forEach((element) => {
      element.addEventListener('click', function () {
        document
          .querySelector('html')
          .classList.remove('cart-open', 'show-cart-recommendations')
      })
    })

  //handle showing gift message textarea
  const addGiftMessageButton = document.querySelector(
    'button#gift-message-show'
  )

  addGiftMessageButton?.addEventListener('click', function () {
    this.hidden = true
    const giftMessageWrapper = document.querySelector('.gift-message-wrapper')
    giftMessageWrapper.hidden = false
    giftMessageWrapper.querySelector('textarea').focus()
  })
}

addCartDrawerFormEventListeners() //init on first page load

async function updateCartDrawer() {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await fetch('/?section_id=cart-drawer') //get section again that will contain the updated values
      const text = await res.text()
      //convert plain text to html
      const html = document.createElement('div')
      html.innerHTML = text

      const selector = '.cart-drawer-section'
      const newBox = html.querySelector(selector).innerHTML
      document.querySelector(selector).innerHTML = newBox
      addCartDrawerFormEventListeners() //re-add event listeners once html has been replaced
      window.initCartRecommendationsSwipers()
      resolve('cart updated')
    } catch (error) {
      console.log('error updating cart drawer: ', error)
      if (window.Sentry) {
        Sentry.captureException(error, { tags: { function: 'updateCartDrawer' } })
      }
      reject(error)
    }
  })
}
